'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ComboboxContext: function() {
        return ComboboxContext;
    },
    ComboboxProvider: function() {
        return ComboboxProvider;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const ComboboxContext = (0, _reactcontextselector.createContext)({
    activeOption: undefined,
    appearance: 'outline',
    focusVisible: false,
    open: false,
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    },
    setOpen () {
    // noop
    },
    size: 'medium'
});
const ComboboxProvider = ComboboxContext.Provider;
